module.exports = __webpack_public_path__ + "img/MarcusDenne@2x.fa68d42e.png";